import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthContext, UserAuthStatus } from "../../context/authContext";
import { useLoading } from "../../context/loadingContext";
import AppContent from "../templates/wrapper/AppContent";
import DeleteAccountForm from "../organisms/forms/deleteAccount/DeleteAccountForm";
import { useDialog } from "../../hooks/useDialog";
import { useToast } from "../../hooks/useToast";
import { attrArrayToMap, formattedPhone, getCountryCode } from "../../helpers/utils";
import axios from "axios";
import { encode } from "base-64";

export default function DeleteAccount() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {deleteBySignInWithEmail, attrInfo, authStatus, sessionInfo, signOut} = useContext(AuthContext);
  const { showToast } = useToast();
  const { showDialog } = useDialog();
  const { setLoading } = useLoading();
  const countryCode = getCountryCode();
  const attrMap = attrArrayToMap(attrInfo);
  
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    if (isLoggedIn === true && authStatus === UserAuthStatus.SignedIn && attrInfo.length > 0 && sessionInfo !== null) {
      showDialog(
        //t("userDelete.areYouSure"),
        "",
        t("userDelete.areYouSureMessage"),
        t("userDelete.yes"),
        true,
        t("userDelete.no"),
        "error",
        onSubmitModal,
        true
      );
      localStorage.removeItem("isLoggedIn");
      setLoading(false);
    }
  }, [authStatus, attrInfo, sessionInfo, localStorage]);
  const onSubmitModal = async () => {
    try {
      const data = {
        SubId: attrInfo[0].Value,
        Username: sessionInfo.username,
        AccessToken: sessionInfo.accessToken,
      };

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/user/delete-user`,
        data,
        {
          headers: {
            Authorization:
              "Basic " +
              encode(
                process.env.REACT_APP_CMS_USERNAME +
                  ":" +
                  process.env.REACT_APP_CMS_PASSWORD
              ),
            "content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
              "Origin, X-Requested-With, Content-Type, Accept",
          },
        }
      );

      signOut(false);
      localStorage.setItem("navigateMessage", "accountDeleted");
      navigate("/");
    } catch (error) {
      showToast(t("userDelete.generalError"));
    }
  };

  const onSubmit = async (values) => {
    try {
      await deleteBySignInWithEmail(
        values.loginMethod === "email"
          ? values.email
          : formattedPhone(values.phone_number, countryCode),
        values.password 
      );
      setLoading(true);
      localStorage.setItem("isLoggedIn", "true");
    } catch (error) {
      if (error.message === "Incorrect username or password.") {
        showToast("error", t("userDelete.errorMessage"));
      }
    }
  };

  return (
    <>
      <AppContent title={t("userDelete.myDeleteAccount")}>
        <DeleteAccountForm
          isLoggedIn={authStatus === UserAuthStatus.SignedIn}
          attrMap={attrMap}
          onSubmit={onSubmit}
        />
      </AppContent>
    </>
  );
}
